import { createContext } from 'react'
import type { PaymentPeriod } from 'client/pages/payment_input/PaymentStepsComponent'

export type DiscountInfo = {
  discountCode: string | null
  validForPaymentPeriodId: PaymentPeriod | null
  originalPrice: number | null
  discountedPrice: number | null
  discountPercentage: number | null
  discountAmount: number | null
} | null

type DiscountContextType = {
  discountInfo: DiscountInfo | null
  setDiscountInfo: (discountInfo: DiscountInfo) => void
}

const DiscountContext = createContext<DiscountContextType | undefined>(undefined)

export default DiscountContext
